import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteInvite } from "@/adapters/api";

export function useDeleteInvite() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => deleteInvite(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["invites"] });
		},
	});
}
